import type { VaccinationCharacteristics } from "@syadem/vaccination-characteristics";
import { useEffect, useState } from "react";
import type { LocaleString } from "../../translations";
import { loadVaccinationCharacteristics } from "../../utils/loadVaccinationCharacteristics";
import { useI18n } from "./useI18n";

export interface VaccinationCharacteristicsState {
  vaccinationCharacteristics: VaccinationCharacteristics | null;
  isLoading: boolean;
  error: unknown;
}

type LocalizedState = VaccinationCharacteristicsState & { locale: LocaleString };

const initialState = (locale: LocaleString): LocalizedState => ({
  locale,
  vaccinationCharacteristics: null,
  isLoading: true,
  error: null,
});

export function useVaccinationCharacteristics(): VaccinationCharacteristicsState {
  const { locale } = useI18n();
  const [state, setState] = useState<LocalizedState>(() => initialState(locale));

  useEffect(() => {
    let active = true;

    loadVaccinationCharacteristics(locale)
      .then((vaccinationCharacteristics) => {
        if (active) setState({ locale, vaccinationCharacteristics, isLoading: false, error: null });
      })
      .catch((error: unknown) => {
        if (active) setState({ locale, vaccinationCharacteristics: null, isLoading: false, error });
      });

    return () => {
      active = false;
    };
  }, [locale]);

  return state.locale === locale ? state : initialState(locale);
}
